<template>
  <b-container v-if="school && school.loaded()" class="mb-5">
    <b-row>
      <b-col>
        <h5>Anschrift</h5>
        <addr :school=this.school :autocomplete=false></addr>
      </b-col>
    </b-row>

    <b-row>
      <b-col>
        <h5>Rechnungsanschrift</h5>
        <invoice-addr :schoolID=school.id v-if=school.id></invoice-addr>
      </b-col>
    </b-row>

    <b-row>
      <b-col>
        <h5>Koordinator</h5>
        <coord :school=this.school :users=this.users></coord>
      </b-col>
    </b-row>

    <b-row>
      <b-col>
        <h5>Kollegium</h5>
        <users :school=this.school :users=this.users :admin=true></users>
      </b-col>
    </b-row>

    <b-row>
      <b-col>
        <h5>Schule löschen</h5>
          <b-button type="button" variant="danger" v-on:click="confirmDelete">Schule löschen</b-button>
      </b-col>
    </b-row>

  </b-container>
</template>
<script>
import {School} from '@/models'
import Address from '@/components/schools/Address'
import InvoiceAddr from '@/components/schools/InvoiceAddress'
import Coordinator from '@/components/schools/Coordinator'
import UsersTable from '@/components/schools/UsersTable'

export default {
  name: 'SchoolsDetails',
  components: {
    addr: Address,
    invoiceAddr: InvoiceAddr,
    coord: Coordinator,
    users: UsersTable
  },
  data: function () {
    return {
      school: new School(),
      users: []
    }
  },

  mounted: function () {
    this.school.id = this.$route.params.id
    this.fetchSchool()
  },

  methods: {
    fetchSchool: function () {
      this.school.fetch().then(this.fetchUsers)
    },

    confirmDelete: function () {
      this.$eventHub.$emit('confirm', this.school.name + ' wirklich löschen?', 'Schule löschen', this.deleteSchool)
    },

    deleteSchool: function () {
      this.axios.delete('/schools/' + this.school.id)
        .then(() => {
          this.$router.push({name: 'admin.schools'})
          this.$eventHub.$emit('alertInfo', 'Schule erfolgreich gelöscht')
        })
        .catch(err => {
          this.$eventHub.$emit('alertError', err)
        })
    },

    fetchUsers: function () {
      this.users = []

      this.axios.get('/schools/' + this.school.id + '/users')
        .then(rsp => {
          rsp.data.forEach(row => {
            this.users.push({
              id: row.id,
              gender: row.gender,
              firstname: row.firstname,
              lastname: row.lastname,
              email: row.email
            })
          })
        })
    }
  }
}
</script>
<style scoped>
  div.row {
    margin-bottom: 30px;
  }
</style>



// WEBPACK FOOTER //
// src/views/admin/schools/Details.vue